'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useOnboardingStore = create(
  persist(
    (set) => ({
      hasCompletedOnboarding: false,
      firstProject: null,

      setOnboardingCompleted: (completed) => set({ hasCompletedOnboarding: completed }),
      setFirstProject: (project) => set({ firstProject: project }),
      resetOnboarding: () => set({
        hasCompletedOnboarding: false,
        firstProject: null
      })
    }),
    {
      name: 'onboarding-storage',
    }
  )
);

export default useOnboardingStore;